import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ReactModal from 'react-modal';
import propTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import moment from 'moment';
import lang from '../../lang';
import { createFetch } from '../../utils';
import { registerAccessToken } from '../Login/actions';

class Notification extends React.Component {
    constructor() {
        super();
        this.state = {
            loading: false,
            records: [],
        };
        this.refreshList = this.refreshList.bind(this);
    }

    componentWillMount() {
        this.refreshList();
    }

    async refreshList(forceRefresh = false) {
        this.setState({ loading: true });
        const { accessToken } = this.props.user;
        const { status, records, message } = await createFetch({
            accessToken,
            path: `gems-update?forceRefresh=${forceRefresh.toString()}`,
            method: 'get',
        });
        if (status !== 200) {
            Swal.fire('An error occured', message, 'error');
        }
        this.setState({ loading: false, records });
    }

    render() {
        const { info: userInfo } = this.props.user;
        const { loading, records } = this.state;
        if (userInfo === undefined || userInfo === null) return null;
        return (
            <ReactModal
                className="meView notification"
                overlayClassName="overlay-me"
                id="notification"
                isOpen={this.props.visible}
                closeTimeoutMS={2000}
                ariaHideApp={false}
                onRequestClose={() => this.props.toggleModal()}
            >
                <Link
                    to="#"
                    onClick={(e) => {
                        e.preventDefault();
                        this.props.toggleModal();
                    }}
                    className="btn-close"
                >
                    <i className="fa fa-times fa-3x" style={{ color: '#222' }} />
                </Link>
                <p className="text-center">
                    {loading ? <i className="fa fa-circle-notch fa-spin fa-4x loading" /> : null}
                </p>
                <div className="notif-list">
                    <h3>
                        Notification&nbsp;&nbsp;
                        <button className="btn-xs btn btn-info" disabled={loading} onClick={() => this.refreshList(true)}>
                            <i className="fa fa-sync" />
                        </button>
                    </h3>
                    <div className="notif-item-content">
                        {
                            records.map((record, index) => (
                                <div className="notif-item" key={record.id}>
                                    <div className="dot">
                                        <i className="fa fa-circle" />
                                    </div>
                                    <div className="text">
                                        <div className="flex">
                                            <h4> Notification {index + 1} - {record.actor.displayName}</h4>
                                            <span className="date">{moment(record.modifiedDate).format('DD-MMM-YYYY')}</span>
                                        </div>
                                        <div>
                                            {record.body.text}
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </ReactModal>
        );
    }
}

Notification.propTypes = {
    visible: propTypes.bool.isRequired,
    toggleModal: propTypes.func.isRequired,
    user: propTypes.object.isRequired,
    registerAccessToken: propTypes.func.isRequired,
    history: propTypes.object.isRequired,
};


const mapDispatchToProps = dispatch => (
    bindActionCreators({
        registerAccessToken,
    }, dispatch)
);

const mapStateToProps = state => ({
    user: state.user,
});


export default connect(mapStateToProps, mapDispatchToProps)(Notification);
